export const agentId = process.env.REACT_APP_AGENT_ID_WIDGET_CHAT;
export const aliasId = process.env.REACT_APP_AGENT_ALIAS_ID;


export const flowCallAgentWidget = "900114098-CALL-AGENT-WIDGET";